import {Injectable} from '@angular/core';
import {ChannelService} from '../../../../../micromate-learn-lib/src/lib/services/LearningChannelService';
import {
    LearningChannelType
} from '../../../../../micromate-learn-lib/src/lib/components/profile/LearningChannel';
import {TeamsChannelDetectorService} from '../teams-channel-detector.service';

@Injectable({
    providedIn: 'root'
})
export class ProfileChannelService implements ChannelService {
    public channel: LearningChannelType;

    constructor(private teamsChannelDetector: TeamsChannelDetectorService) {
        this.channel = this.teamsChannelDetector.detectTeamsChannel();
    }

    public getChannel(): LearningChannelType {
        return this.channel;
    }

    public setChannel(): void {
        throw new Error('Not implemented');
    }
}
